$(document).ready(function () {
    // CHECK IF THIS IS DENTIST TYPE PAGE:
    if ( $('.global-section').hasClass('dentist-management-page') ) {
        var apiUrl = 'api/articles';
        var pattern = /article/;
        var key = 'article';
        var wrapperClass = 'jsManageArticleWrapper';
        var lastIndexClass = 'jsLastManageArticleIndex';
        var buttonClass = 'jsShowMoreLessManageArticleBtn';

        function jsManageArticlePagination() {
            var btn = $(this);
            jsManagementPagination(pattern, apiUrl, key, lastIndexClass,wrapperClass,buttonClass, btn);
        }

        hideShowButtons(pattern, buttonClass , $('.' + lastIndexClass).text().trim().split(' ')[3]);
        $('.' + buttonClass).click(jsManageArticlePagination);

        window.onpopstate = function(event) {
            if ( (event.state && event.state.counter) || $('.dentist-management-page').length ) {
                window.location.reload();
            }
        };
    }
});

function resetManageArticlePagination() {
    resetManagePagination(/article/, 'api/articles', 'article', 'jsLastManageArticleIndex', 'jsManageArticleWrapper', 'jsShowMoreLessManageArticleBtn');
}
